<script setup lang="ts">
import type { NodeViewProps } from '@tiptap/vue-3';

import type { UserInvitationOptions } from '#layers/access/utils/extensions/user-invitation';
import { NodeViewWrapper } from '@tiptap/vue-3';
import { computed } from 'vue';

const props = defineProps<NodeViewProps>();

const options = computed(() => props.extension.options as UserInvitationOptions);

const email = computed(() => props.node.attrs.email as string);
const fullName = computed(() => props.node.attrs.fullName as string | null);
const recipientType = computed(() => props.node.attrs.recipientType as 'existing_member' | 'new_email');
const userId = computed(() => props.node.attrs.userId as string | null);

const user = computed(() => userId.value ? options.value.getUser?.(userId.value) : undefined);
const displayLabel = computed(() => user.value?.fullName || fullName.value || email.value);

function handleDelete() {
	props.deleteNode();
}
</script>

<template>
	<NodeViewWrapper
		as="span"
		class="inline-flex shrink-0 items-center align-middle"
	>
		<DFieldGroup>
			<DBadge
				:variant="selected ? 'subtle' : 'soft'"
				color="neutral"
				size="md"
				contenteditable="false"
				:ui="{ base: 'border-s-0 bg-elevated pr-1' }"
			>
				<template #leading>
					<span
						v-if="recipientType === 'new_email'"
						class="flex size-4 items-center justify-center rounded-full bg-inverted"
					>
						<DIcon
							name="lucide:mail"
							class="size-2.5 text-inverted"
						/>
					</span>
					<UserAvatar
						v-else-if="user"
						:user
						class="size-4"
					/>
					<span
						v-else
						class="
							flex size-4 items-center justify-center rounded-full bg-inverted text-[10px] leading-none font-medium
							text-inverted
						"
					>
						{{ email.charAt(0).toUpperCase() }}
					</span>
				</template>
				{{ displayLabel }}
			</DBadge>
			<DButton
				class="border-s-0"
				color="neutral"
				:variant="selected ? 'subtle' : 'soft'"
				size="xs"
				icon="lucide:x"
				contenteditable="false"
				:aria-label="$t('common.remove')"
				@click.stop="handleDelete"
			/>
		</DFieldGroup>
	</NodeViewWrapper>
</template>
